(() => {
  if (window.mdBookingPopupBound) return;
  window.mdBookingPopupBound = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('a[href], .md-servicify-popup-trigger');
    if (!trigger) return;

    const isBookingLink = trigger.getAttribute('href')?.trim() === '#booking';
    if (!isBookingLink && !trigger.classList.contains('md-servicify-popup-trigger')) return;

    const proxy = document.getElementById('MDBookingPopupProxy');
    if (!proxy || !proxy.dataset.href) return;

    event.preventDefault();
    proxy.click();
  });
})();
